import { render } from "./CertificateManager.vue?vue&type=template&id=47a55460&scoped=true"
import script from "./CertificateManager.vue?vue&type=script&lang=js"
export * from "./CertificateManager.vue?vue&type=script&lang=js"

import "./CertificateManager.vue?vue&type=style&index=0&id=47a55460&scoped=true&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/magic-shop-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a55460"]])

export default __exports__